import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Rete", -1)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Referral code", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col-sm-12 col-md-6" }
const _hoisted_11 = { class: "box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Permessi", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_network_user_selector = _resolveComponent("network-user-selector")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_module_selector = _resolveComponent("module-selector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                readonly: "true",
                placeholder: "Verrà generato al salvataggio",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.referralCode) = $event))
              }, null, 512), [
                [_vModelText, _ctx.user.referralCode]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_network_user_selector, {
                  label: "Upliner gestione",
                  modelValue: _ctx.user.reteGestioneParent,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.reteGestioneParent) = $event)),
                  userIdentifier: _ctx.user.identifier
                }, null, 8, ["modelValue", "userIdentifier"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_network_user_selector, {
                  label: "Upliner commerciale",
                  modelValue: _ctx.user.reteCommercialeParent,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.reteCommercialeParent) = $event)),
                  userIdentifier: _ctx.user.identifier
                }, null, 8, ["modelValue", "userIdentifier"])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_12
          ]),
          default: _withCtx(() => [
            _createVNode(_component_module_selector, {
              modelValue: _ctx.user.appModules,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.appModules) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}